// src/Pt.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Pt_default = createIcon({
  displayName: "Pt",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "red", x: "17", y: "1", width: "32", height: "32", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("rect", { id: "green", x: "1", y: "1", width: "16", height: "32", fill: "#00AE82" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Combined Shape",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17 27C22.5228 27 27 22.5228 27 17C27 11.4772 22.5228 7 17 7C11.4772 7 7 11.4772 7 17C7 22.5228 11.4772 27 17 27ZM17 25C21.4183 25 25 21.4183 25 17C25 12.5817 21.4183 9 17 9C12.5817 9 9 12.5817 9 17C9 21.4183 12.5817 25 17 25Z",
        fill: "#FBB43A"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Rectangle 56",
        d: "M22.5 11.5V18C22.5 21.0376 20.0376 23.5 17 23.5C13.9624 23.5 11.5 21.0376 11.5 18V11.5H22.5Z",
        fill: "#FBB43A"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Rectangle 56_2",
        d: "M12 12H22V18C22 20.7614 19.7614 23 17 23C14.2386 23 12 20.7614 12 18V12Z",
        fill: "#FF1A26"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Path",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 18C14 19.6569 15.3431 21 17 21C18.6569 21 20 19.6569 20 18V14H14V18Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ jsx("rect", { id: "Rectangle 57", x: "16.5", y: "15", width: "1", height: "1", fill: "#4D98FF" }),
    /* @__PURE__ */ jsx("rect", { id: "Rectangle 57_2", x: "15", y: "17", width: "1", height: "1", fill: "#4D98FF" }),
    /* @__PURE__ */ jsx("rect", { id: "Rectangle 57_3", x: "18", y: "17", width: "1", height: "1", fill: "#4D98FF" }),
    /* @__PURE__ */ jsx("rect", { id: "Rectangle 57_4", x: "16.5", y: "19", width: "1", height: "1", fill: "#4D98FF" }),
    /* @__PURE__ */ jsx("rect", { id: "Rectangle 57_5", x: "16.5", y: "17", width: "1", height: "1", fill: "#4D98FF" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});

export {
  Pt_default
};
